import { useState } from 'react'
import { IStartPhoneRegistrationInput } from '~/@api/generated-api-types/global.types'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

export const useRegVerStart = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { showAlert } = useAlert()

  const verifyStart = async (data: IStartPhoneRegistrationInput) => {
    setIsLoading(true)
    try {
      const { data: response } =
        await getApi().userAuthAppApiControllerStartPhoneRegistration(data)

      if ('success' in response) {
        showAlert('success', 'SMS overenie bolo úspešne odoslané!')
        return response
      }

      throw new Error(
        'Nastala neznáma chyba pri odosielaní SMS pre registráciu.'
      )
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    } finally {
      setIsLoading(false)
    }
  }

  return { verifyStart, isLoading }
}
